import React from 'react';
import useKYCStore from '../../store/kycStore';
import { FiUser, FiCreditCard, FiFileText } from 'react-icons/fi';
import IconWrapper from '../print-steps/IconWrapper';

const KYCStepIndicator: React.FC = () => {
  const { currentStep, setCurrentStep } = useKYCStore();

  const steps = [
    { title: 'Personal Info', icon: FiUser },
    { title: 'Bank Details', icon: FiCreditCard },
    { title: 'Documents', icon: FiFileText },
  ];

  // Step indices are offset by 1 because the first step (authentication) is not shown
  // in the step indicator
  const getDisplayStep = (index: number) => index + 1;

  return (
    <div className="w-full max-w-3xl mx-auto mb-4 sm:mb-8 px-2">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const displayStepIndex = getDisplayStep(index);
          
          return (
            <React.Fragment key={index}>
              {/* Step dot */}
              <div 
                className={`flex flex-col items-center ${
                  displayStepIndex <= currentStep ? 'cursor-pointer' : 'cursor-not-allowed'
                }`}
                onClick={() => {
                  if (displayStepIndex <= currentStep) {
                    setCurrentStep(displayStepIndex);
                  }
                }}
              >
                <div 
                  className={`w-8 sm:w-12 h-8 sm:h-12 rounded-full flex items-center justify-center text-xs sm:text-sm relative
                    ${displayStepIndex < currentStep 
                      ? 'bg-green-500 text-white' 
                      : displayStepIndex === currentStep
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-300 text-gray-600'
                    }
                  `}
                >
                  {displayStepIndex < currentStep ? (
                    '✓'
                  ) : (
                    <IconWrapper icon={step.icon} className="w-4 h-4 sm:w-5 sm:h-5" />
                  )}
                </div>
                
                <span className={`mt-1 sm:mt-2 text-[10px] sm:text-xs md:text-sm text-center block w-16 sm:w-auto
                  ${displayStepIndex === currentStep ? 'font-medium text-blue-600' : 'text-gray-500'}`}
                >
                  {step.title}
                </span>
              </div>

              {/* Connector line between dots (except after the last one) */}
              {index < steps.length - 1 && (
                <div className="flex-1 h-0.5 mx-1 sm:mx-2 md:mx-4">
                  <div 
                    className="h-full" 
                    style={{
                      background: `linear-gradient(to right, 
                        ${displayStepIndex < currentStep ? '#10B981' : '#D1D5DB'} 50%, 
                        ${displayStepIndex + 1 <= currentStep ? '#10B981' : '#D1D5DB'} 50%
                      )`
                    }}
                  ></div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default KYCStepIndicator;
